import React from "react";
import Privacycontent from "../privacycontent/privacycontent";
import "./terms.scss";
const Terms = () => {
  return (
    <div className="container_">
      <div className="terms">
        <div className="termstop">
          <h2>Terms of service</h2>
          <p>
            Please read our terms below to learn more about your rights and
            responsibilities as a AutoRed user.
          </p>
        </div>
        <Privacycontent />
      </div>
    </div>
  );
};

export default Terms;
